export default (store) => {
    return store.state.pusher;
};



// WEBPACK FOOTER //
// ./src/app/store/users/actions/get-pusher.js